import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["handleNavigation", "imageIds", "listRef", "shouldDisplayCount", "shouldDisplayCaption", "caption", "countMessage", "direction", "priorityLimit"];
import React from 'react';
import PropTypes from 'prop-types';
import CarouselImage from '../CarouselImage';
import { withTitle } from '../../../HOC';
const CarouselRender = _ref => {
  let {
      handleNavigation,
      imageIds,
      listRef,
      shouldDisplayCount,
      shouldDisplayCaption,
      caption,
      countMessage,
      direction,
      priorityLimit
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "carousel"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "carousel__button carousel__button--previous",
    role: "button",
    "aria-label": "Previous Slide",
    onClick: () => handleNavigation(direction.back)
  }, /*#__PURE__*/React.createElement("div", {
    className: "arrow arrow--left"
  })), /*#__PURE__*/React.createElement("div", {
    className: "carousel__list",
    ref: listRef
  }, imageIds.map((imageId, index) => /*#__PURE__*/React.createElement(CarouselImage, _extends({
    key: imageId,
    priority: index < priorityLimit,
    imageId: imageId
  }, otherProps)))), /*#__PURE__*/React.createElement("div", {
    className: "carousel__button carousel__button--next",
    role: "button",
    "aria-label": "Next Slide",
    onClick: () => handleNavigation(direction.next)
  }, shouldDisplayCount && /*#__PURE__*/React.createElement("p", {
    "data-testid": "count"
  }, countMessage), /*#__PURE__*/React.createElement("div", {
    className: "arrow arrow--right"
  }))), shouldDisplayCaption && /*#__PURE__*/React.createElement("div", {
    className: "carousel__details",
    "data-testid": "carousel-details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "caption"
  }, caption)));
};
CarouselRender.propTypes = {
  caption: PropTypes.string,
  shouldDisplayCaption: PropTypes.bool.isRequired,
  imageIds: PropTypes.array,
  displayCount: PropTypes.bool,
  listRef: PropTypes.object,
  countMessage: PropTypes.number,
  direction: PropTypes.object.isRequired,
  handleNavigation: PropTypes.func.isRequired,
  shouldDisplayCount: PropTypes.bool.isRequired,
  priorityLimit: PropTypes.number
};
CarouselRender.defaultProps = {
  listRef: null,
  imageIds: [],
  caption: '',
  displayCount: false,
  countMessage: null,
  priorityLimit: 0
};
export default withTitle(CarouselRender);
//# sourceMappingURL=CarouselRender.js.map